import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
  name: "appDate",
})
export class AppDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}
  transform(value: Date | string | undefined | null): string {
    if (value) {
      const result = this.datePipe.transform(value, "medium");
      if (result == null) {
        return "";
      }
      return result;
    }
    return "";
  }
}
